























































import Vue, { PropType } from 'vue'
import Component from 'vue-class-component'
import ModalV2 from '@/components/modals/ModalV2.vue'
import Checkbox from '@/components/inputsV2/Checkbox.vue'
import ScrollView from '@/components/ScrollView.vue'
import InputV2 from '@/components/inputsV2/InputV2.vue'
import { IFacility, IUserDTO } from '@zunta/configurations'
import { helpers } from 'vuelidate/lib/validators'
import InputValidator from '@/components/inputsV2/InputValidator.vue'
import { User } from '@/classes/User'
import Api from '@/api'

const atLeastOne = (param: any) => (value: any) => helpers.len(value) > 0 || param
@Component({
  components: { InputValidator, InputV2, ScrollView, Checkbox, ModalV2 },
  props: {
    value: {
      type: Object as PropType<IUserDTO>,
      required: true
    }
  }
})
export default class EmailFacilitiesModal extends Vue {
  searchValue: string = ''
  localValue: Partial<IUserDTO> = {
    managerEmailFacilitiesAll: true,
    managerEmailFacilities: []
  }
  user: User = Api.getUser() as User

  validations (): any {
    return {
      localValue: {
        managerEmailFacilities: {
          required: atLeastOne(this.localValue.managerEmailFacilitiesAll)
        }
      }
    }
  }

  get facilitiesList (): IFacility[] {
    return this.$store.state.facility.facilities
  }

  get filteredFacilities (): IFacility[] {
    if (!this.searchValue) {
      return this.facilitiesList
    }
    return this.facilitiesList
      .filter((facility: IFacility) =>
        facility.name.toLowerCase().includes(this.searchValue.toLowerCase()))
  }

  mounted () {
    this.localValue = JSON.parse(JSON.stringify(this.$props.value))
    this.$watch('value', (newValue) => {
      this.localValue = JSON.parse(JSON.stringify(newValue))
    })
  }

  isChecked (facilityId: number): boolean {
    return !!(this.localValue.managerEmailFacilities &&
      this.localValue.managerEmailFacilities.length &&
      this.localValue.managerEmailFacilities.includes(facilityId))
  }

  changeSelectedFacilities (value: boolean) {
    if (value) {
      this.localValue.managerEmailFacilities = []
    }
  }

  toggleFacility (facilityId: number, value: boolean) {
    if (!this.localValue.managerEmailFacilities) {
      this.localValue.managerEmailFacilities = []
    }

    if (value) {
      this.localValue.managerEmailFacilities.push(facilityId)
    } else {
      this.localValue.managerEmailFacilities =
        this.localValue.managerEmailFacilities.filter((facility: number) => facilityId !== facility)
    }

    this.$v.$touch()
  }

  save () {
    this.$v.$touch()

    if (this.$v.$anyError) {
      this.$emit('close')
      return
    }

    this.$emit('input', this.localValue)
    this.$emit('close')
  }
}
